import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  box: {
    background: theme.secondary.s5,
    borderRadius: 8,
    height: 'fit-content',
  },
  titleBlock: {
    ...dFlex(),
    height: 44,
    minHeight: 44,
    borderRadius: `${theme.borderRadius.md} ${theme.borderRadius.md} 0 0`,
    background: theme.secondary.s1,
    padding: '0 16px',
    width: '100%',
    textAlign: 'center',

    '> *': {
      width: '100%',
    },
  },
  childrenBox: {
    padding: 16,
  },
}));

export default useStyles;
